/** A clock skew to use for considering a token valid. */
export const CLOCK_SKEW = 5 * 60 * 1000;
export function getEndpoint(request, override) {
    if (typeof override === 'function') {
        return override(request);
    }
    const match = /^(https?:\/\/[^\/?#]+)/.exec(request.url);
    return match ? match[1] : window.location.origin;
}
/**
 * Obtains the session storage key used to cache authentication token expiry times.
 * @param endpoint The endpoint value.
 */
export function getSessionStorageKey(endpoint) {
    return `sentry-auth: ${endpoint}`;
}
